import { useSelector } from 'react-redux'
import { RootState, Subtask } from 'constants/interfaces'
import { useMemo } from 'react'
import { findScopedResult } from '../TasksOverview/model/results'

interface IProps {
  subtask: Pick<Subtask, 'st_id' | 'tid'>
  resultContextId: string
  recurrence_ts?: string | null
}

export const useResults = ({ subtask, resultContextId, recurrence_ts }: IProps) => {
  const { allResults, tasks, taskFromInsights } = useSelector((state: RootState) => state.tasks_v2)

  const task =
    taskFromInsights?.tid === subtask?.tid ? taskFromInsights : tasks?.find((item) => item.tid === subtask?.tid)
  const recurrence = recurrence_ts !== undefined ? recurrence_ts : task?.recurrence_ts

  return useMemo(
    () =>
      subtask ? findScopedResult(allResults?.[subtask.tid], subtask.st_id, resultContextId, recurrence) : undefined,
    [allResults, subtask, resultContextId, recurrence]
  )
}
